export default "__VITE_ASSET__4eca19c1__"